<template>
  <div>
    <ul v-if="props.item.optionNames?.length">
      <li v-for="(optionName, optionIndex) in props.item.optionNames" :key="`product-${props.item.productId}-option-${optionIndex}`" class="text-sm">{{ optionName }}</li>
    </ul>
    <ul
      class="flex flex-col"
      :class="{
        'md:pt-2': props.item.optionNames?.length,
      }"
    >
      <li v-if="props.item.deliveryTimeTextForHome" class="text-sm">{{ t['w.basket.delivery.home']() }}: {{ props.item.deliveryTimeTextForHome }}</li>
      <li v-if="props.item.deliveryTimeTextForParcelTerminal" class="text-sm">
        {{ t['w.basket.delivery.parcel_terminal']() }}: {{ props.item.deliveryTimeTextForParcelTerminal }}
      </li>
      <li v-if="props.item.deliveryTimeTextForSelfPickup" class="text-sm">{{ t['w.basket.delivery.self_pickup']() }}: {{ props.item.deliveryTimeTextForSelfPickup }}</li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import * as t from '~/messages'

interface Product {
  productId: number
  optionNames: string[] | null
  deliveryTimeTextForHome: string | null
  deliveryTimeTextForParcelTerminal: string | null
  deliveryTimeTextForSelfPickup: string | null
}

const props = defineProps<{
  item: Product
}>()
</script>
